import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import axios from '../../../axios-dates/axios-dates';

import EditAppConfigForm from '../../../components/Admin/EditAppConfigForm/EditAppConfigForm';
import Spinner from '../../../components/UI/Spinner/Spinner';

class EditAppConfig extends Component {
  state = {
    appConfig: {},
    loading: true,
    error: null
  }

  inputHandler = event => {
    const currentConfig = {...this.state.appConfig};
    currentConfig[event.target.id] = event.target.value;
    this.setState({appConfig: currentConfig});
  }

  submissionHandler = e => {
    e.preventDefault();
    const url = '/admin/update-app-config.php';

    const payload = {
      jwt: this.props.token,
      appConfig: this.state.appConfig
    }

    axios.post(url, payload)
      .then(res => {
        console.log(res)
        if (res.data.success === 1) {
          // go back to main menu
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0;
          this.props.history.push('/pt/landing');
          return null;
        } else {
          if (res.data.msg) {
            this.setState({error: res.data.msg});
          } else {
            this.setState({error: res.data});
          }
        }
      })
      .catch(err => {
        this.setState({error: err.message});
      })
  }

  componentDidMount () {
    const payload = {
      jwt: this.props.token,
    }

    axios.post('/admin/get-app-config.php', payload)
      .then(res => {
        if (res.data.success === 1) {
          this.setState({appConfig: res.data.appConfig, loading: false});
        } else {
          if (res.data.msg) {
            this.setState({error: res.data.msg, loading: false});
          } else {
            this.setState({error: res.data, loading: false});
          }
        }
      })
      .catch(err => {
        this.setState({error: err.message, loading: false});
      })
  }

  render() {
    return (
      <>
      {this.state.loading ? <Spinner /> :
        (this.state.error ? <p>{this.state.error}</p> :
          <EditAppConfigForm
            language={this.props.language}
            appConfig={this.state.appConfig}
            inputHandler={this.inputHandler}
            submissionHandler={this.submissionHandler}/>)
      }
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.pt.token,
    language: state.rs.language,
    typeId: state.admin.selectedTypeId
  };
};

export default withRouter(connect(mapStateToProps)(EditAppConfig));
